<script>
	const metadata = require('core/metadata');
	const moment = require('moment');
	const utilities = require('utilities');
	const model = require('model/model');
	const accountSettingsUtilities = require('utilities/accountSettingsUtilities');
	const WHATS_NEW_DISMISS = accountSettingsUtilities.settings.WHATS_NEW_DISMISS;
	const routeContext = require('core/routeContext');

	const BLACKLIST = [
		// new RegExp('\/teacher-signup'),
		// new RegExp('\/onboarding-.*')
	];

	const whatsNew = metadata.whatsNew;
	let body = null;
	let headline = null;
	let linkCode = null;
	let linkText = null;
	let linkUrl = null;
	let linkOpensNewTab = null;
	let startDate = null;
	let vimeoId = null;

	if (whatsNew) {
		body = whatsNew.body;
		headline = whatsNew.headline;
		linkCode = whatsNew.linkCode;
		linkText = whatsNew.linkText;
		linkUrl = whatsNew.linkUrl;
		linkOpensNewTab = whatsNew.linkOpensNewTab;
		startDate = whatsNew.startDate;
		vimeoId = whatsNew.vimeoId;
	}

	module.exports = {
		modelData: ['whatsNewDismissSession', 'userContext'],
		components: {
			modal: require('./modal.vue').default,
			'outbound-link': require('./outbound-link.vue').default
		},
		data() {
			let target = linkOpensNewTab ? '_blank' : '_self';
			return {
				whatsNewDismissLongTerm: null,
				body,
				headline,
				linkCode,
				linkText,
				linkUrl,
				target,
				startDate,
				vimeoId
			};
		},
		mounted() {
			this.$subscribe('modal-closed', id => {
				if (id !== 'whats-new-modal') {
					return true; // let some other handler take this
				}

				let player = this.$refs.player;
				if (player && player.pause) {
					player.pause();
				}

				model.set('whatsNewDismissSession', startDate);

				return false;
			});
		},
		watch: {
			userContext(userContext, oldUserContext) {
				if (!oldUserContext && userContext && !userContext.classCode) {
					this.checkAccountSettingsAndShowModal();
				}
			}
		},
		methods: {
			checkAccountSettingsAndShowModal() {
				accountSettingsUtilities.read(WHATS_NEW_DISMISS).then(value => {
					this.whatsNewDismissLongTerm = value;
					this.shouldShowModal();
				});
			},
			shouldShowModal() {
				let pathname = routeContext.pathname;
				let now = moment();
				let startMoment = moment(startDate);
				let newMessageToUser = !this.whatsNewDismissSession || moment(this.whatsNewDismissSession) < startMoment;
				let notDismissedLongTerm = !this.whatsNewDismissLongTerm || moment(this.whatsNewDismissLongTerm) < startMoment;
				let blacklistMatch = BLACKLIST.some(re => re.test(pathname));
				// let campaignMatch = this.userContext && this.userContext.campaign && this.userContext.campaign === 'parentPopup';
				// Only show logged in users once per session
				if (!blacklistMatch && startDate && startMoment < now && this.userContext && newMessageToUser && notDismissedLongTerm) {
					// don't override if other modals are in place
					utilities.openModal('#whats-new-modal', null, false);
				}
			},
			dismissWhatsNewModal() {
				accountSettingsUtilities.update(WHATS_NEW_DISMISS, startDate);
				this.whatsNewDismissLongTerm = startDate;
				this.close();
			},
			close() {
				utilities.closeModals();
			},
			onLinkClick() {
				if (!linkOpensNewTab) {
					this.dismissWhatsNewModal();
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	#whats-new-modal {
		.modal-window-wrap {
			max-width: 800px;

			.vimeo-player {
				width: 100%;
				min-height: 480px;
			}

			.modal-content-main {
				min-height: 480px;

				p {
					margin-bottom: 0rem;
				}

				.link-container {
					margin: 1rem 0 0.5rem 0;
					text-align: center;
				}
			}
		}

		.dismiss-whats-new {
			cursor: pointer;

			&:hover {
				color: $c-slate-dark;
				text-decoration: underline;
			}
		}
	}
</style>
<template>
	<modal
		ref="modal"
		id="whats-new-modal"
		:ok="false">
		<template
			v-if="headline"
			slot="header-container">
			<h2 v-html="headline"></h2>
		</template>
		<template slot="content">
			<div class="modal-content-body">
				<div
					class="rte"
					v-if="body"
					v-html="body"></div>
				<vimeo-player
					v-if="vimeoId"
					ref="player"
					:video-id="vimeoId"></vimeo-player>
				<p
					v-if="linkText && linkUrl"
					class="link-container">
					<a
						v-if="!linkCode"
						:href="linkUrl"
						:target="target"
						class="link button"
						@click="onLinkClick"
						v-html="linkText">
					</a>
					<outbound-link
						v-if="linkCode"
						class="link button"
						:href="linkUrl"
						:data-outbound-link="linkCode"
						:target="target"
						:on-click="onLinkClick">
						<span v-html="linkText"></span>
					</outbound-link>
				</p>
				<div class="text-centered">
					<button
						class="button"
						:class="{
							'-small': linkText && linkUrl,
							'-outline': linkText && linkUrl
						}"
						@click="close">
						Close
					</button>
				</div>
				<div class="margin-top-medium text-centered">
					<button
						class="dismiss-whats-new button -link -link-muted font-small"
						@click="dismissWhatsNewModal">
						Don't show this message again.
					</button>
				</div>
			</div>
		</template>
	</modal>
</template>
